export const SET_DB_RECEIPT_DETAILS = 'SET_DB_RECEIPT_DETAILS'
export const SET_RECEIPT_ITEM_TYPES = 'SET_RECEIPT_ITEM_TYPES'
export const SET_RECEIPT_ITEM_TYPE_ENUM = 'SET_RECEIPT_ITEM_TYPE_ENUM'
export const CLEAR_RECEIPT = 'CLEAR_RECEIPT'
export const REVERT_RECEIPT = 'REVERT_RECEIPT'
export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const SET_RECEIPT_WORKVIEW_ITEM = 'SET_RECEIPT_WORKVIEW_ITEM'
export const SET_RECEIPT_DLNS = 'SET_RECEIPT_DLNS'
export const SET_FAILED_VALIDATION = 'SET_FAILED_VALIDATION'
export const SET_REDIRECT_BACK_TO = 'SET_REDIRECT_BACK_TO'
export const SET_RECEIPT = 'SET_RECEIPT'
export const SET_REFUND_STATUS = 'SET_REFUND_STATUS'
export const SET_LOADING_EXISTING = 'SET_LOADING_EXISTING'

// const dummyItem = {
//   // Type INCOMING
//   // "Type": {"typeID": 2, "Description": "LLC Initial Filing"},
//   "ReceiptItemID": 152438,
//   "Type": {Description: "LLC Initial Filing"},
//   "Description": "Exploding Envelopes Inc.",
//   "Quantity": 1,
//   "Amount": 30,
//   "Payor": {
//     "Name": 'Raya',
//     "Address": '101 Gem St.',
//     "City": 'Heart',
//     "State": 'Kumandra',
//     "Zip": '80321',
//   },
//   "Batch": {
//     "BatchNum": '7787',
//     "CreatedAt": new Date('Jan 1, 1999'),
//     "PostNum": '117',
//     "PostDate": new Date('Mar 1, 2001'),
//   },
//   "ProcessedBy": "Sadie Baskins",
//   "RefCheckNum": "001",
//   "DLNNum": "8472812",
//   "SourceID": 0
// }

// const StructuredDummyData = {
//   "ReceiptID": 73540,
//   "ReceiptNum": "000199172",
//   "Status": "Balanced",
//   "CreatedAt": "0001-01-01T00:00:00",
//   "Payments": [dummyItem, dummyItem],
//   "Charges": [dummyItem, dummyItem, dummyItem]
// }

const initialState = {
  receipt: {},
  originalReceipt: {},
  receiptItemTypes: {},
  currentUser: {},
  workviewItem: null,
  receiptExtra: {
    RequireBalanceYN: false,
    waivedReceiptYN: false,
  },
  receiptItemTypeIDs: {},
  receiptDLNs: [],
  failedValidation: false,
  redirectBackTo: '',
  refundStatuses: {},
  loadingExisting: false,
}

const ReceiptReducer = (state = initialState, action) => {
  //console.log(state);
  switch (action.type) {
    case SET_DB_RECEIPT_DETAILS: {
      return {
        ...state,
        receipt: action.receipt,
        originalReceipt: action.receipt,
      }
    }
    case SET_RECEIPT_ITEM_TYPES: {
      return {
        ...state,
        receiptItemTypes: action.types,
      }
    }
    case CLEAR_RECEIPT: {
      return initialState
    }
    case REVERT_RECEIPT: {
      let paymentsList = []
      state.receiptDLNs.forEach((element) => {
        if (element.Type.TypeDesc == 'Payment') {
          paymentsList.push({
            DLNNum: element.DLN,
            payor: {
              Name: '',
              Address: '',
              City: '',
              State: '',
              Zip: '',
              Phone: '',
              Address3: '',
              Address2: '',
              Country: '',
            },
          })
        }
      })

      return {
        ...state,
        receipt: { Payments: paymentsList },
        failedValidation: false,
      }
    }
    case SET_CURRENT_USER: {
      return {
        ...state,
        currentUser: action.currentUser,
      }
    }
    case SET_RECEIPT_WORKVIEW_ITEM: {
      return {
        ...state,
        workviewItem: action.workviewItem,
        isCorrespondence: action.isCorrespondence,
      }
    }
    case SET_RECEIPT_ITEM_TYPE_ENUM: {
      let idEnum = {}
      action.types.map((item) => {
        idEnum[item.Name] = item.ReceiptItemTypeId
        return null
      })
      return {
        ...state,
        receiptItemTypeIDs: idEnum,
      }
    }
    case SET_RECEIPT_DLNS: {
      return {
        ...state,
        receiptDLNs: action.data,
      }
    }
    case SET_FAILED_VALIDATION: {
      return {
        ...state,
        failedValidation: true,
      }
    }
    case SET_REDIRECT_BACK_TO: {
      return {
        ...state,
        redirectBackTo: action.redirectBackTo,
      }
    }
    case SET_RECEIPT: {
      return {
        ...state,
        receipt: action.receipt,
        originalReceipt: action.originalReceipt,
      }
    }
    case SET_REFUND_STATUS: {
      return {
        ...state,
        refundStatuses: action.data,
      }
    }
    case SET_LOADING_EXISTING: {
      return {
        ...state,
        loadingExisting: action.loadingExisting,
      }
    }
    default:
      return state
  }
}

export default ReceiptReducer
